import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebookF, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import './Footer.css';
import logoImg from '../../assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/"><img src={logoImg} alt="Shakti Yoga Logo" className="footer-logo-img" /></Link>
            <p className="footer-desc">
              Find balance through mindful movement, inner peace, and holistic wellness.
            </p>
            <div className="footer-socials">
              <a href="#ig" className="social-icon"><FaInstagram /></a>
              <a href="#fb" className="social-icon"><FaFacebookF /></a>
              <a href="#yt" className="social-icon"><FaYoutube /></a>
              <a href="#li" className="social-icon"><FaLinkedinIn /></a>
            </div>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/classes">Classes</Link></li>
              <li><Link to="/offerings">Offerings</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4 className="footer-heading">Our Classes</h4>
            <ul>
              <li><Link to="/classes/hatha">Hatha Yoga</Link></li>
              <li><Link to="/classes/vinyasa">Vinyasa Flow</Link></li>
              <li><Link to="/classes/meditation">Meditation</Link></li>
              <li><Link to="/classes/kids">Kids Yoga</Link></li>
              <li><Link to="/classes/private">Private Yoga</Link></li>
            </ul>
          </div>

          <div className="footer-links footer-contact">
            <h4 className="footer-heading">Contact</h4>
            <ul className="contact-list">
              <li><span>📍</span> Bengaluru</li>
              <li><span>☎</span> +91 98765 43210</li>
              <li><span>✉</span> info@shaktiyoga.com</li>
            </ul>
            
            <h4 className="footer-heading mt-4">Newsletter</h4>
            <form className="newsletter-form" onSubmit={e => e.preventDefault()}>
              <input type="email" placeholder="Email Address" required />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 Shakti Yoga. All Rights Reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="sep">|</span>
            <Link to="/terms">Terms & Conditions</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
